import React from "react";
import "./CustomAlert.css";

export type AlertVariant = "success" | "error" | "warning" | "info";

export interface CustomAlertProps {
  message: string;
  variant?: AlertVariant;
  onClose: () => void;
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  message,
  variant = "info",
  onClose,
}) => {
  return (
    <div className="custom-alert-overlay">
      <div className={`custom-alert-box`}>
        <p className="custom-alert-message">{message}</p>
        <button
          className={`custom-alert-button custom-alert-button-${variant}`}
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;
